var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          !_vm.ljcType
            ? _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "pageFrom",
                          attrs: {
                            inline: "",
                            size: "small",
                            model: _vm.pageFrom,
                            "label-position": "right",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "名称：" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "客户名称",
                                    size: "small",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.pageFrom.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "name", $$v)
                                    },
                                    expression: "pageFrom.name",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                      size: "small",
                                    },
                                    on: { click: _vm.search },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.miniProgramCustomer
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "归属公司：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        placeholder: "请输入选择",
                                        filterable: "",
                                        remote: "",
                                        "remote-method": _vm.remoteMethod,
                                        loading: _vm.searchLoading,
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.pageFrom.companyId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageFrom,
                                            "companyId",
                                            $$v
                                          )
                                        },
                                        expression: "pageFrom.companyId",
                                      },
                                    },
                                    _vm._l(_vm.searchOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "合作状态：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.cooperationStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageFrom,
                                        "cooperationStatus",
                                        $$v
                                      )
                                    },
                                    expression: "pageFrom.cooperationStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.cooperationStatusEnum,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.miniProgramCustomer
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "维护人：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidth",
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择维护人",
                                        filterable: "",
                                        "filter-method": _vm.handleUserSearch,
                                      },
                                      on: { change: _vm.search },
                                      model: {
                                        value: _vm.pageFrom.maintainerId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageFrom,
                                            "maintainerId",
                                            $$v
                                          )
                                        },
                                        expression: "pageFrom.maintainerId",
                                      },
                                    },
                                    _vm._l(_vm.userOption, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label:
                                            "" +
                                            item.realName +
                                            (item.flag == 1
                                              ? "（当前登陆人）"
                                              : ""),
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "运营方式：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择运营方式",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.ljcType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "ljcType", $$v)
                                    },
                                    expression: "pageFrom.ljcType",
                                  },
                                },
                                _vm._l(
                                  _vm.platformTypeEnum,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:mini:program:customer:add"],
                                  expression:
                                    "['admin:mini:program:customer:add']",
                                },
                              ],
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.AddCoupon("ADD")
                                },
                              },
                            },
                            [_vm._v("新增客户")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "客户ID", "min-width": "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "名称", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "归属公司",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cooperationStatusDesc",
                  label: "合作状态",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ljcType",
                  label: "运营方式",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              scope.row.ljcType === 1
                                ? "自营"
                                : scope.row.ljcType === 2
                                ? "代运营"
                                : scope.row.ljcType
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ticketTypeDesc",
                  label: "票务类型",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "creditAmount",
                  label: "授信额度",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "balance", label: "余额", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "frozenAmount",
                  label: "冻结金额",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "220", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "mini:program:customers:funds-records:list",
                                ],
                                expression:
                                  "['mini:program:customers:funds-records:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.CapitalAllocation(scope.row)
                              },
                            },
                          },
                          [_vm._v("资金记录")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:mini:program:customer:update"],
                                expression:
                                  "['admin:mini:program:customer:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.AddCoupon(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:mini:program:customer:product:list",
                                ],
                                expression:
                                  "['admin:mini:program:customer:product:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.goDistributor(
                                  scope.row,
                                  "/business/clientManage/distributor"
                                )
                              },
                            },
                          },
                          [_vm._v("产品配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:pintuan:customer:product:list"],
                                expression:
                                  "['admin:pintuan:customer:product:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.goDistributor(
                                  scope.row,
                                  "/business/clientManage/pintuanBusiness"
                                )
                              },
                            },
                          },
                          [_vm._v("拼团产品配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:cake:list"],
                                expression: "['admin:customer:cake:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.goDistributor(
                                  scope.row,
                                  "/business/clientManage/dangaoBusiness"
                                )
                              },
                            },
                          },
                          [_vm._v("蛋糕产品配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:third:sku:list"],
                                expression: "['admin:customer:third:sku:list']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.settingThdGoods(scope.row)
                              },
                            },
                          },
                          [_vm._v("三方商品授权")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:product:gross"],
                                expression: "['admin:customer:product:gross']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.reltScopeObj(scope.row)
                              },
                            },
                          },
                          [_vm._v("毛利配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:mini:program:customer:delete"],
                                expression:
                                  "['admin:mini:program:customer:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.DeleteRecode(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "三方商品利润配置",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "530px" } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                _vm._l(_vm.rateListArr, function (item, i) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: i,
                      attrs: { label: item.typeName, name: String(i) },
                    },
                    [
                      item.type === 1
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "20px" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 4 } }, [
                                    _vm._v(
                                      "\n              展示商品最低毛利率：\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          step: 1,
                                          min: -1,
                                          max: 100000,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: item.rate.grossMargin,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item.rate,
                                              "grossMargin",
                                              $$v
                                            )
                                          },
                                          expression: "item.rate.grossMargin",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "padding-top": "10px",
                                          },
                                        },
                                        [_vm._v("%")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { push: 2, span: 12 } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                请输入可以在小程序商品展示的最低毛利率。-1为不限制\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                如设最低毛利率为20%，那么低于20%毛利率的商品将不显示\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 2
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "20px" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 4 } }, [
                                    _vm._v(
                                      "\n                  展示商品最低毛利率：\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          step: 1,
                                          min: -1,
                                          max: 100000,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: item.rate.grossMargin,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item.rate,
                                              "grossMargin",
                                              $$v
                                            )
                                          },
                                          expression: "item.rate.grossMargin",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "20px",
                                            "padding-top": "10px",
                                          },
                                        },
                                        [_vm._v("%")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { push: 2, span: 12 } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    请输入可以在小程序商品展示的最低毛利率。-1为不限制\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    如设最低毛利率为20%，那么低于20%毛利率的商品将不显示\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 3
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "20px" } },
                            [
                              _c("div", { staticClass: "box-items" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                  最低毛利率：\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        step: 1,
                                        min: -1,
                                        max: 100000,
                                        label: "描述文字",
                                      },
                                      model: {
                                        value: _vm.brandKfc,
                                        callback: function ($$v) {
                                          _vm.brandKfc = $$v
                                        },
                                        expression: "brandKfc",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "20px",
                                          "padding-top": "10px",
                                        },
                                      },
                                      [_vm._v("%")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-btn" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info", plain: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditNew(item)
                                          },
                                        },
                                      },
                                      [_vm._v("同步所有品牌毛利")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "box-text" }, [
                                  _vm._v(
                                    "\n                    将批量同步所有品牌毛利率为设定值\n                  "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: item.rate,
                                    height: "250",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "brandId", label: "id" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "brandName",
                                      center: "",
                                      label: "品牌名称",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "毛利率" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input-number", {
                                                attrs: {
                                                  precision: 0,
                                                  step: 1,
                                                  min: -1,
                                                  max: 1000000,
                                                  label: "描述文字",
                                                },
                                                model: {
                                                  value: scope.row.grossMargin,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "grossMargin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.grossMargin",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box-chil" }, [
                                _vm._v(
                                  "\n                    如设置最低毛利率为20%,那么低于20%毛利率的商品将不展示。-1为不限制毛利率\n                  "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 4
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "20px" } },
                            [
                              _c("div", { staticClass: "box-items" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                  最低毛利率：\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        step: 1,
                                        min: -1,
                                        max: 100000,
                                        label: "描述文字",
                                      },
                                      model: {
                                        value: _vm.brandNew,
                                        callback: function ($$v) {
                                          _vm.brandNew = $$v
                                        },
                                        expression: "brandNew",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "20px",
                                          "padding-top": "10px",
                                        },
                                      },
                                      [_vm._v("%")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-btn" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info", plain: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditNew(item)
                                          },
                                        },
                                      },
                                      [_vm._v("同步所有品牌毛利")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "box-text" }, [
                                  _vm._v(
                                    "\n                    将批量同步所有品牌毛利率为设定值\n                  "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: item.rate,
                                    height: "250",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "brandId", label: "id" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "brandName",
                                      center: "",
                                      label: "品牌名称",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "毛利率" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input-number", {
                                                attrs: {
                                                  precision: 0,
                                                  step: 1,
                                                  min: -1,
                                                  max: 1000000,
                                                  label: "描述文字",
                                                },
                                                model: {
                                                  value: scope.row.grossMargin,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "grossMargin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.grossMargin",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "box-chil" }, [
                                _vm._v(
                                  "\n                    如设置最低毛利率为20%,那么低于20%毛利率的商品将不展示。-1为不限制毛利率\n                  "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === 5
                        ? _c(
                            "div",
                            { staticStyle: { "padding-top": "20px" } },
                            [
                              _c(
                                "div",
                                { staticClass: "box-intens" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-intens-title" },
                                    [
                                      _vm._v("客户供货商模式 "),
                                      _c("span", [
                                        _vm._v(
                                          "使用供应商的成本价计算给客户的供货价"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: item.filmRate.supplyPriceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item.filmRate,
                                            "supplyPriceType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.filmRate.supplyPriceType ",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "box-text-storing",
                                                },
                                                [_vm._v(" 按成本价结算")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "box-intens-margin" },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "box-text-storing",
                                                },
                                                [
                                                  _vm._v(
                                                    "按百分比加价，单张加价"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("el-input-number", {
                                                attrs: {
                                                  precision: 0,
                                                  step: 1,
                                                  min: -1,
                                                  max: 100000,
                                                  label: "描述文字",
                                                },
                                                model: {
                                                  value:
                                                    _vm.supplyPriceValueReta,
                                                  callback: function ($$v) {
                                                    _vm.supplyPriceValueReta =
                                                      $$v
                                                  },
                                                  expression:
                                                    "supplyPriceValueReta",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "20px",
                                                    "padding-top": "10px",
                                                  },
                                                },
                                                [_vm._v("%")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "box-text-end" },
                                                [
                                                  _vm._v(
                                                    "\n                  如单张电影票成本价为50，加价10%，客户的结算价为：50+50*0.1=55元\n                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: 3 } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "box-text-storing" },
                                            [_vm._v("按固定金额加价，单张加价")]
                                          ),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 0,
                                              step: 1,
                                              min: -1,
                                              max: 100000,
                                              label: "描述文字",
                                            },
                                            model: {
                                              value: _vm.supplyPriceValueSup,
                                              callback: function ($$v) {
                                                _vm.supplyPriceValueSup = $$v
                                              },
                                              expression: "supplyPriceValueSup",
                                            },
                                          }),
                                          _vm._v("元\n                "),
                                          _c(
                                            "div",
                                            { staticClass: "box-text-end" },
                                            [
                                              _vm._v(
                                                "\n                  如单张电影票成本价为50，加价2元，客户的结算价为50+2=52元\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "box-intens-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box-intens-text" },
                                    [_vm._v("客户售价模式")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value:
                                          item.filmRate.customerPriceStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item.filmRate,
                                            "customerPriceStatus",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.filmRate.customerPriceStatus ",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("按建议售价销售"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("按供货价销售"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("div", { staticClass: "box-text-storing" }, [
                                  _vm._v("加价配置:"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "box-bottom" },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value:
                                            item.filmRate.customerPriceType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item.filmRate,
                                              "customerPriceType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.filmRate.customerPriceType ",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "box-text-storing",
                                              },
                                              [_vm._v("不加价")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-text-end" },
                                              [
                                                _vm._v(
                                                  "\n                  如单张电影票建议销售价为50，不加价，最终售价为：50元\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "box-bottom-margin" },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 2 } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "box-text-storing",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "按百分比加价，单张加价"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("el-input-number", {
                                                  attrs: {
                                                    precision: 0,
                                                    step: 1,
                                                    min: -1,
                                                    max: 100000,
                                                    label: "描述文字",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.customerPriceValueReta,
                                                    callback: function ($$v) {
                                                      _vm.customerPriceValueReta =
                                                        $$v
                                                    },
                                                    expression:
                                                      "customerPriceValueReta",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "20px",
                                                      "padding-top": "10px",
                                                    },
                                                  },
                                                  [_vm._v("%")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "box-text-end",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          item.filmRate
                                                            .customerPriceStatus ===
                                                            1
                                                            ? "如单张电影票建议销售价为50，加价10%，客户的结算价为50+50*0.1=55元"
                                                            : "如单张电影票客户供货价为50，加价10%，最终售价为：50+50*0.1=55元"
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 3 } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "box-text-storing",
                                              },
                                              [
                                                _vm._v(
                                                  "按固定全额加价，单张加价"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("el-input-number", {
                                              attrs: {
                                                precision: 0,
                                                step: 1,
                                                min: -1,
                                                max: 1000000,
                                                label: "描述文字",
                                              },
                                              model: {
                                                value:
                                                  _vm.customerPriceValueSup,
                                                callback: function ($$v) {
                                                  _vm.customerPriceValueSup =
                                                    $$v
                                                },
                                                expression:
                                                  "customerPriceValueSup",
                                              },
                                            }),
                                            _vm._v("元\n                "),
                                            _c(
                                              "div",
                                              { staticClass: "box-text-end" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      item.filmRate
                                                        .customerPriceStatus ===
                                                        1
                                                        ? "如单张电影票建议销售价为50，加价2元，客户的结算价为50+2=52元"
                                                        : "如单张电影票客户供货价为50，加价2元，最终售价为：50+2=52元"
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRelatEdit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("AddCouponVue", {
        ref: "AddCouponVueRef",
        attrs: {
          getList: _vm.getList,
          miniProgramCustomer: _vm.miniProgramCustomer,
        },
      }),
      _vm._v(" "),
      _c("CapitalAllocationVue", { ref: "CapitalAllocationVueRef" }),
      _vm._v(" "),
      _c("DeleteCouponVue", {
        ref: "DeleteCouponVueRef",
        attrs: { getList: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }